import apiService from './apiService';
import type { CallbackTicket } from './callbackTicketService';
import type { TakeoverStateName } from './conversationService';

/** A customer waiting for the salon: live request, callback request, or unanswered in a taken-over chat. */
export interface WaitingContact {
  contact_key: string;
  customer_phone: string;
  customer_name: string | null;
  agent_number: string | null;
  state: TakeoverStateName;
  waiting_since: string;
  reason: string | null;
  summary: string | null;
  reply_window_until: string | null;
  conversation_id: number | null;
  deadline_at: string | null;
}

export interface LiveCallSummary {
  call_sid: string;
  customer_phone: string;
  customer_name: string | null;
  agent_number: string | null;
  started_at: string;
  status: 'live' | 'transferring';
  last_step: string | null;
}

export interface ActiveChat {
  contact_key: string;
  customer_phone: string;
  customer_name: string | null;
  last_message_at: string;
  preview: string | null;
  conversation_id: number | null;
}

/** `GET /api/live/overview` (contract livecenter §5, rueckruf-ticket §5). */
export interface LiveOverview {
  waiting: WaitingContact[];
  live_calls: LiveCallSummary[];
  active_chats: ActiveChat[];
  /**
   * Open Rückruf-Tickets of the phone agent, oldest first, without test calls.
   * Not in `waiting` on purpose: those are WhatsApp contacts (`contact_key`).
   */
  callback_tickets: CallbackTicket[];
}

export const EMPTY_LIVE_OVERVIEW: LiveOverview = { waiting: [], live_calls: [], active_chats: [], callback_tickets: [] };

class LiveOverviewService {
  async getOverview(): Promise<LiveOverview> {
    return apiService.get<LiveOverview>('/live/overview');
  }
}

export const liveOverviewService = new LiveOverviewService();
export default liveOverviewService;
